import React, { useEffect, useContext, useState } from 'react';
import HTMLText from './../HTMLText';
import ArtworldContext from './../../context/ArtworldContext';
import axios from 'axios';
import LoadingSpinner from './../LoadingSpinner'

// Components
import DetailsLinks from './DetailsLinks';
import HowToCite from './HowToCite';
import Feedback from './Feedback';
import Editorial from './Editorial';
import Sources from './Sources';

const spinner = <LoadingSpinner loadingSize={15} loadingCss={{ display: 'inline-block' }} />

var _ = require('lodash');

const Person = () => {
  const context = useContext(ArtworldContext);

  const [categories, setCategories] = useState(spinner)
  // const [makersRepository, setMakersRepository] = useState(spinner)
  const [place_long, setPlaceLong] = useState(spinner)
  const [place_short, setPlaceShort] = useState(spinner)
  const [sales, setSales] = useState(spinner)
  const [personSources, setPersonSources] = useState('')

  const ReturnDetailsLinks = props => {
    return props.items ? <DetailsLinks
      items={props.items}
      showLinks={true}
    /> : ''
  }

  useEffect(() => {

    // CATEGORIES
    axios
      .get(`${process.env.REACT_APP_API2_URL}persons/categories/${context.activeRecord.id}`)
      .then(res => {
        if (res.data.response) {
          setCategories(<DetailsLinks
            items={res.data.response}
            showLinks={false}
          />)
        }
      });

    // makers_repository
    // axios
    //   .get(`${process.env.REACT_APP_API2_URL}persons/makerRepositories/${context.activeRecord.id}`)
    //   .then(res => {
    //     if (res.data.response) {
    //       setMakersRepository(<ReturnDetailsLinks items={res.data.response} />)
    //     }
    //   });

    // place_long
    axios
      .get(`${process.env.REACT_APP_API2_URL}persons/placesLong/${context.activeRecord.id}`)
      .then(res => {
        if (res.data.response) {
          setPlaceLong(<ReturnDetailsLinks items={res.data.response} />)
        }
      });

    // place_short
    axios
      .get(`${process.env.REACT_APP_API2_URL}persons/placesShort/${context.activeRecord.id}`)
      .then(res => {
        if (res.data.response) {
          setPlaceShort(<ReturnDetailsLinks items={res.data.response} />)
        }
      });

    // sales
    axios
      .get(`${process.env.REACT_APP_API2_URL}persons/sales/${context.activeRecord.id}`)
      .then(res => {
        if (res.data.response) {
          setSales(<ReturnDetailsLinks items={res.data.response} />)
        }
      });

    // sources
    axios
      .get(`${process.env.REACT_APP_API2_URL}persons/sources/${context.activeRecord.id}`)
      .then(res => {
        if (res.data.response) {
          setPersonSources(res.data.response)
        }
      });

  }, [context.activeRecord]);

  const dates = () => {
    let date = '';

    if (context.activeRecord.date1_year) {
      date += context.activeRecord.date1_year;
    }

    if (
      context.activeRecord.date2_year &&
      context.activeRecord.date1_year !== context.activeRecord.date2_year
    ) {
      if (!_.isEmpty(date)) date += ' - ';
      date += context.activeRecord.date2_year;
    }

    return date;
  };

  /**
   * Places of work are in the past - thus we only show places which URN starts with a 3
   */
  // const placesOfWork = context.activeRecord && context.activeRecord.places ? context.activeRecord.places.filter(place => {
  //   if (place.urn.startsWith('3')) {
  //     return place
  //   }
  // }) : ''

  return (
    <div>
      <table className="table is-bordered is-striped is-fullwidth is-size-7 details-table">
        <tbody>
          <tr>
            <th>Category:</th>
            <td>
              {categories}
            </td>
          </tr>

          <tr>
            <th>Nationality:</th>
            <td>{context.activeRecord.nationality}</td>
          </tr>

          <tr>
            <th>Earliest / Latest Date:</th>
            <td>{dates()}</td>
          </tr>

          <tr>
            <th>Name Variant:</th>
            <td>{context.activeRecord.name_variant}</td>
          </tr>

          <tr>
            <th>Place(s) of residence:</th>
            <td>
              {place_long}
            </td>
          </tr>

          <tr>
            <th>Place(s) of work:</th>
            <td>
              {place_short}
            </td>
          </tr>

          <tr>
            <th>Sales:</th>
            <td>
              {sales}
            </td>
          </tr>

          {/* <tr>
            <th>Training:</th>
            <td>
              work in progress - hide when empty - waiting for example from Richard
              <DetailsLinks items={context.activeRecord.places} showLinks={true} />
            </td>
          </tr> */}

          {/*  <tr>
            <th>Employment:</th>
            <td>
              work in progress - hide when empty - waiting for example from Richard
              <DetailsLinks items={context.activeRecord.places} showLinks={true} /> 
            </td>
          </tr>*/}

          <tr>
            <th colSpan="2">Note:</th>
          </tr>
          <tr>
            <td colSpan="2"><HTMLText text={context.activeRecord.text} /></td>
          </tr>

        </tbody>
      </table>

      <Sources sources={personSources} />

      <HowToCite />

      <Feedback />

      <Editorial />

    </div>
  );
};

export default Person;
